<div class="right-sidebar-container" 
     [class.collapsed]="(layoutService.isRightSidebarCollapsed$ | async)"
     [class.expanded]="!(layoutService.isRightSidebarCollapsed$ | async)">
  @let rightSidebarCollapsed = layoutService.isRightSidebarCollapsed$ | async;
  <button
    type="button"
    class="right-sidebar-toggle"
    [class.collapsed]="rightSidebarCollapsed"
    [attr.aria-label]="rightSidebarCollapsed ? 'Expand right sidebar' : 'Collapse right sidebar'"
    [attr.title]="rightSidebarCollapsed ? 'Expand panel' : 'Collapse panel'"
    (click)="layoutService.toggleRightSidebar()"
  >
    <span class="right-sidebar-toggle__control" aria-hidden="true">
      <mat-icon class="right-sidebar-toggle__icon">
        {{ rightSidebarCollapsed ? 'keyboard_double_arrow_left' : 'keyboard_double_arrow_right' }}
      </mat-icon>
    </span>
  </button>
  <div class="right-sidebar-content">
    <!-- Show project-status and notifications only when NOT on task/issue details pages -->
    <!-- Show notifications only on dashboard page -->
    @if (!isOnTaskDetailsPage && !isOnIssueDetailsPage && !isOnRevisionDetailsPage && !isOnRequestDetailsPage) {
      <ng-container [ngSwitch]="layoutService.rightSidebarContent$ | async">
        <app-project-status #projectStatusComponent *ngSwitchCase="'project-status'"></app-project-status>
        <ng-container *ngSwitchCase="'notifications'">
          @if (isOnDashboardPage) {
          <app-notifications></app-notifications>
          }
        </ng-container>
      </ng-container>
    }
    
    <!-- Show task-status only when on task details page and a task is loaded -->
    @if (isOnTaskDetailsPage) {
      @if ((layoutService.taskDetailsSidebarEmptyState$ | async) !== true) {
        <app-task-status [taskId]="currentTaskId" [refreshTrigger]="statusSidebarRefreshService.refreshTrigger()"></app-task-status>
      } @else {
        <div class="task-sidebar-empty-state" role="status">
          <mat-icon class="task-sidebar-empty-icon" aria-hidden="true">assignment</mat-icon>
          <p class="task-sidebar-empty-title">No task details</p>
          <p class="task-sidebar-empty-text">Status, assignees, and dates will show here once a task is available.</p>
        </div>
        }
     }
    
    <!-- Show issue-status only when on issue details page -->
    @if (isOnIssueDetailsPage) {
      <app-issue-status [issueId]="currentIssueId" [refreshTrigger]="statusSidebarRefreshService.refreshTrigger()"></app-issue-status>
    }

    <!-- Show revision-status only when on revision details page -->
    @if (isOnRevisionDetailsPage) {
      <app-revision-status [revisionId]="currentRevisionId" [refreshTrigger]="statusSidebarRefreshService.refreshTrigger()"></app-revision-status>
    }

    <!-- Show request-status only when on request details page -->
    @if (isOnRequestDetailsPage) {
      <app-request-status [requestId]="currentRequestId" [refreshTrigger]="statusSidebarRefreshService.refreshTrigger()"></app-request-status>
    }
  </div>
</div>
